<template>
  <div class="choose">
    <div
      class="item"
      :class="{ ischose: choosenum == index }"
      v-for="(item, index) in chooseArr"
      :key="index"
      @click="clickChoose(index)"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chooseArr: Array,
  },
  data() {
    return {
      choosenum: 0,
    };
  },
  methods:{
      clickChoose(index){
          this.choosenum = index;
          this.$emit('choosenum',index)
      }
  }
};
</script>

<style lang="scss" scoped>
.choose {
  .item {
    font-size: 0.32rem;
    font-weight: 500;
    color: #999999;
  }
  .ischose {
    font-weight: bold;
    color: #000000;
    position: relative;
  }
  .ischose::after {
    content: "";
    display: block;
    width: 0.53rem;
    height: 0.06rem;
    background: linear-gradient(67deg, #f9b94d 0%, #fdcb76 100%);
    border-radius: 0.02rem;
    position: absolute;
    bottom: -0.18rem;
    left: 0;
    right: 0;
    margin: auto;
  }
  display: flex;
  justify-content: space-between;
}
</style>